export default {
  communities: [],
  community: null,
  unreadCount: 0
};
